import GeneralPayeeSettings from '@/models/Products/ProductSettings/DefaultSettings/GeneralPayee/GeneralPayeeSettings';

export default class UpdateGeneralPayeeSettingsRequest extends GeneralPayeeSettings {
    updatedAt: Date;

    public constructor(settings: GeneralPayeeSettings, updatedAt: Date) {
        super();
        this.updatedAt = updatedAt;
        if (settings) {
            this.overridable = settings.overridable;
            this.restrictNumberOfPayees = settings.restrictNumberOfPayees;
            this.maximumNumberOfPayees = +settings.maximumNumberOfPayees;
            this.restrictInboundPaymentsToPayeesOnly = settings.restrictInboundPaymentsToPayeesOnly;
            this.restrictOutboundPaymentsToPayeesOnly = settings.restrictOutboundPaymentsToPayeesOnly;
        }
    }
}